import script from "./History.vue?vue&type=script&setup=true&lang=js"
export * from "./History.vue?vue&type=script&setup=true&lang=js"

import "./History.vue?vue&type=style&index=0&id=77393f4e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77393f4e"]])

export default __exports__